export default function CardsSection() {
  const cards = [
    {
      title: '国产剧热播榜',
      desc: '《庆余年2》《繁花》《三体》等年度大剧持续更新，国产精品剧集一网打尽',
      icon: 'ri-fire-line',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20aesthetic%20with%20warm%20lantern%20lighting%2C%20ancient%20Chinese%20architecture%20in%20soft%20focus%2C%20cinematic%20mood%2C%20dark%20background%20with%20warm%20accents%2C%20film%20drama%20poster%20style%2C%20no%20text%2C%20elegant%20composition&width=600&height=400&seq=card-01&orientation=landscape',
    },
    {
      title: '日韩剧场精选',
      desc: '《怪物》《黑暗荣耀》《First Love》口碑炸裂，日韩高分剧集全集收录',
      icon: 'ri-global-line',
      img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20atmospheric%20visual%20with%20romantic%20night%20scene%2C%20Seoul%20city%20lights%20bokeh%2C%20emotional%20cinematic%20mood%2C%20warm%20amber%20and%20cool%20blue%20contrast%2C%20k-drama%20aesthetic%2C%20no%20text%2C%20soft%20focus%20background&width=600&height=400&seq=card-02&orientation=landscape',
    },
    {
      title: '欧美大片专区',
      desc: '漫威DC超级英雄系列、HBO精品剧集、Netflix原创内容实时同步上线',
      icon: 'ri-vidicon-line',
      img: 'https://readdy.ai/api/search-image?query=Hollywood%20blockbuster%20visual%20with%20dramatic%20explosion%20effects%20in%20distance%2C%20dark%20cinematic%20color%20grading%2C%20epic%20movie%20poster%20composition%2C%20warm%20orange%20and%20teal%20contrast%2C%20professional%20film%20aesthetic%2C%20no%20text&width=600&height=400&seq=card-03&orientation=landscape',
    },
    {
      title: '热血动漫全集',
      desc: '《咒术回战》《鬼灭之刃》《海贼王》超清画质无水印，动漫迷的快乐星球',
      icon: 'ri-rocket-line',
      img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20visual%20with%20dynamic%20action%20composition%2C%20vibrant%20warm%20colors%20on%20dark%20background%2C%20energy%20burst%20effects%2C%20anime%20art%20aesthetic%2C%20cinematic%20lighting%2C%20no%20text%2C%20dramatic%20mood&width=600&height=400&seq=card-04&orientation=landscape',
    },
    {
      title: '综艺纪录片库',
      desc: '《奔跑吧》《向往的生活》等热门综艺，BBC和国家地理纪录片高清收录',
      icon: 'ri-tv-2-line',
      img: 'https://readdy.ai/api/search-image?query=Documentary%20nature%20scene%20with%20dramatic%20landscape%20lighting%2C%20warm%20sunset%20glow%2C%20cinematic%20aerial%20view%2C%20epic%20natural%20wonder%2C%20professional%20photography%20style%2C%20dark%20edges%20with%20warm%20center%2C%20no%20text&width=600&height=400&seq=card-05&orientation=landscape',
    },
    {
      title: '经典老片重温',
      desc: '《大话西游》《霸王别姬》《无间道》等华语经典修复版，高清画质回味无穷',
      icon: 'ri-time-line',
      img: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20film%20nostalgic%20visual%20with%20warm%20sepia%20tones%2C%20old%20theater%20atmosphere%2C%20film%20reel%20texture%2C%20golden%20age%20cinema%20aesthetic%2C%20dark%20rich%20background%2C%20no%20text%2C%20vintage%20movie%20mood&width=600&height=400&seq=card-06&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            精选内容
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            六大内容板块全面覆盖，满足你的每一种观影口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/50 overflow-hidden cursor-pointer transition-all duration-300 hover:border-accent-500/20"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 w-9 h-9 rounded-lg bg-background-50/80 backdrop-blur-sm flex items-center justify-center">
                  <i className={`${card.icon} text-accent-500 text-base`}></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-100 mb-2">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}